import React, { useId } from "react";
import "./PmsOccupancyDetails.css";

const MESSAGES = {
  en: {
    title: "Daily occupancy", date: "Day to inspect", sold: "Sold / inventory",
    occupancy: "Occupancy", category: "Category", rooms: "Rooms", hint: "Hover over the chart or choose a day.",
    capacityUnknown: "Inventory unavailable", empty: "No room categories available.",
  },
  es: {
    title: "Ocupación del día", date: "Día a consultar", sold: "Vendidas / inventario",
    occupancy: "Ocupación", category: "Categoría", rooms: "Habitaciones", hint: "Pasa por el gráfico o elige un día.",
    capacityUnknown: "Inventario no disponible", empty: "No hay categorías de habitación disponibles.",
  },
  ca: {
    title: "Ocupació del dia", date: "Dia a consultar", sold: "Venudes / inventari",
    occupancy: "Ocupació", category: "Categoria", rooms: "Habitacions", hint: "Passa pel gràfic o tria un dia.",
    capacityUnknown: "Inventari no disponible", empty: "No hi ha categories d'habitació disponibles.",
  },
};

function number(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export default function PmsOccupancyDetails({ day, days, categories, totalRooms, colors, languageId, locale, onDayChange }) {
  const titleId = useId();
  const copy = MESSAGES[languageId] || MESSAGES.en;
  const integer = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 });
  const percentage = new Intl.NumberFormat(locale, { style: "percent", maximumFractionDigits: 1 });
  const ratio = (sold, capacity) => `${integer.format(number(sold))}/${capacity > 0 ? integer.format(capacity) : "—"}`;
  const occupancy = (sold, capacity) => capacity > 0 ? percentage.format(number(sold) / capacity) : "—";

  return (
    <aside className="pd-occupancyDetails" aria-labelledby={titleId}>
      <div className="pd-occupancyDetailsHead">
        <h4 id={titleId}>{copy.title}</h4>
        <select aria-label={copy.date} value={day?.dateIso || ""} onChange={(event) => onDayChange(event.target.value)}>
          {days.map((row) => (
            <option key={row.dateIso} value={row.dateIso}>
              {new Date(`${row.dateIso}T00:00:00`).toLocaleDateString(locale, { weekday: "short", day: "2-digit", month: "long" })}
            </option>
          ))}
        </select>
        <p>{copy.hint}</p>
      </div>
      <dl className="pd-occupancyTotals">
        <div>
          <dt>{copy.sold}</dt>
          <dd title={totalRooms > 0 ? undefined : copy.capacityUnknown}>{ratio(day?.occupiedRooms, totalRooms)}</dd>
        </div>
        <div>
          <dt>{copy.occupancy}</dt>
          <dd>{occupancy(day?.occupiedRooms, totalRooms)}</dd>
        </div>
      </dl>
      <div className="pd-occupancyCategories">
        <table>
          <thead><tr><th scope="col">{copy.category}</th><th scope="col">{copy.rooms}</th><th scope="col">%</th></tr></thead>
          <tbody>
            {categories.map((category) => (
              <tr key={category.key}>
                <th scope="row">
                  <span className="pd-occupancyCategoryName">
                    <i aria-hidden="true" style={{ backgroundColor: colors[category.key] || colors.cat_other || "#63c1c7" }} />
                    {category.label}
                  </span>
                </th>
                <td title={category.capacity > 0 ? copy.sold : copy.capacityUnknown}>{ratio(day?.[category.key], category.capacity)}</td>
                <td>{occupancy(day?.[category.key], category.capacity)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!categories.length && <p className="pd-occupancyEmpty">{copy.empty}</p>}
      </div>
    </aside>
  );
}
